function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';
var UndrawWorkTime = function UndrawWorkTime(_props) {
  var props = Object.assign({}, _props);
  var primaryColor = props.primaryColor || defaultProps.primaryColor;
  var style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 975.26 825.18",
    style: style
  }, props), React.createElement("ellipse", {
    cx: 91,
    cy: 703.78,
    rx: 41.4,
    ry: 6.35,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 688.12,
    cy: 712.42,
    rx: 41.4,
    ry: 6.35,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 586.13,
    cy: 771.25,
    rx: 41.4,
    ry: 6.35,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 225.15,
    cy: 656.4,
    rx: 41.4,
    ry: 6.35,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 237.47,
    cy: 773.99,
    rx: 237.47,
    ry: 51.19,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M942.25 568.89c-6.41 15.45-14.82 30.26-26.59 41.62-14.34 13.84-32.15 21.39-51.22 25a154.27 154.27 0 0 1-17 2.2c-15.07 1.16-30.5.39-45.3-1.22a535.59 535.59 0 0 1-106.7-22.83q-8.55-2.76-17-5.81-12.75-4.57-25.27-9.81c-34-14.21-69.15-32.33-105.32-26.71-17.53 2.73-34 11-51.57 13.46a92.21 92.21 0 0 1-36.84-2.62 126.59 126.59 0 0 1-17-5.87 193.44 193.44 0 0 1-35.32-20c-26.5-18.52-50.28-41.48-78.18-57.52-30.76-17.69-64.81-26.1-99.5-32.37q-8.47-1.53-17-2.92c-16.05-2.65-32.14-5.1-48-8-15.28-2.82-30.83-6.27-44.13-14.75-9.49-6.05-17.47-14.43-24.79-23.26A277.49 277.49 0 0 1 61 364.26q-.75-1.5-1.47-3c-14.69-30.14-24.57-63-30.63-97-.18-1-.35-2-.52-3-5.7-33.33-7.78-67.79-7.15-102l.06-3c.39-16.89 1.44-33.71 3-50.29 1.12-11.66 2.62-23.76 8.66-33.56s15.88-16.09 25.68-21.33c43.34-23.07 84.85-29.49 131.43-18.31 7.48 1.79 14.93 3.72 22.38 5.72 5.67 1.52 11.34 3.09 17 4.67 39.13 10.91 78.16 22.52 118.61 26q5.86.51 11.73.78 11.61.54 23.22.24a401.19 401.19 0 0 0 59.44-6.12q8.52-1.47 17-3.26c24.4-5.09 48.58-11.88 72.37-19.39q7.29-2.3 14.56-4.68c10.92-3.57 21.84-7.21 32.78-10.75 32.66-10.59 65.48-20.26 99.29-24.16q4.34-.49 8.68-.87c2.77-.24 5.55-.43 8.32-.57 52.45-2.8 105.5 9.85 152 35.74q8.66 4.81 17 10.24 11.57 7.53 22.43 16.2c14.84 11.85 28.73 25.34 39.31 41.55 10.31 15.79 17 33.52 20.85 52.16.21 1 .41 2 .59 3 5.65 30.09 3.89 62.36-2.45 92.51-.67 3.16-1.38 6.33-2.12 9.49-.23 1-.47 2-.71 3-6.84 28.51-15.58 56.94-13.3 86.09.29 3.67.75 7.31 1.35 10.91.17 1 .34 2 .53 3 4.46 23.78 14.6 46.34 20.68 69.89a215.32 215.32 0 0 1-9.35 134.73z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M864.44 159.27h83.19c-.18-1-.38-2-.59-3h-82.6V46.36q-8.34-5.42-17-10.24v120.15h-152V.38c-2.77.14-5.55.33-8.32.57s-5.79.54-8.68.87v154.45h-217l-.52-.57L579.15 25.97c-10.94 3.54-21.86 7.18-32.78 10.75l-86.93 95.39V60.79q-8.49 1.78-17 3.26v71.35L383 70.17q-11.61.28-23.22-.24l78.16 85.77-.52.57h-208V43.16c-5.66-1.58-11.33-3.15-17-4.67v117.78H21.27l-.06 3h191.23v102H28.36c.17 1 .34 2 .52 3h183.56v97H59.51q.72 1.5 1.47 3h151.46v99.26q8.52 1.4 17 2.92V364.27h213v212a126.59 126.59 0 0 0 17 5.87V364.27h219v243.57q8.46 3.06 17 5.81V364.27h152V637.7a154.27 154.27 0 0 0 17-2.2V364.27h66.48c-.19-1-.36-2-.53-3h-66v-97h77.9c.24-1 .48-2 .71-3h-78.56zm-17 0v102h-152v-102zm-169 102h-219v-102h219zm-449-102h210l3 2.73v99.27h-213zm0 202v-97h213v97zm230 0v-97h219v97zm388 0h-152v-97h152z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M774.36 89.03h-1.32a3.23 3.23 0 0 0 1.61-2.62c0-2.06-2.53-3.75-5.62-3.75h-39.4c-3.09 0-5.63 1.69-5.63 3.75 0 2.07 2.54 3.76 5.63 3.76h1.32a3.24 3.24 0 0 0-1.61 2.62c0 1.76 1.84 3.25 4.3 3.65h-11.36c-3.1 0-5.63 1.69-5.63 3.75s2.53 3.76 5.63 3.76h39.41c3.1 0 5.63-1.69 5.63-3.76 0-1.76-1.84-3.24-4.31-3.64h11.35c3.09 0 5.62-1.69 5.62-3.76s-2.53-3.76-5.62-3.76zM347.2 124.8h-1.32a3.28 3.28 0 0 0 1.61-2.62c0-2.07-2.53-3.76-5.63-3.76h-39.41c-3.1 0-5.63 1.69-5.63 3.76 0 2.06 2.53 3.75 5.63 3.75h1.31a3.27 3.27 0 0 0-1.6 2.62c0 1.77 1.84 3.25 4.3 3.65h-11.34c-3.1 0-5.63 1.69-5.63 3.76s2.53 3.75 5.63 3.75h39.41c3.1 0 5.63-1.69 5.63-3.75 0-1.77-1.85-3.25-4.31-3.65h11.35c3.09 0 5.62-1.69 5.62-3.76s-2.53-3.75-5.62-3.75zM834.82 277.86h-1.32a3.28 3.28 0 0 0 1.61-2.62c0-2.06-2.53-3.75-5.63-3.75h-39.41c-3.1 0-5.63 1.69-5.63 3.75s2.53 3.75 5.63 3.75h1.31a3.26 3.26 0 0 0-1.6 2.62c0 1.76 1.84 3.25 4.3 3.65h-11.35c-3.09 0-5.62 1.69-5.62 3.75s2.53 3.76 5.62 3.76h39.42c3.09 0 5.63-1.69 5.63-3.76 0-1.76-1.85-3.24-4.31-3.64h11.35c3.09 0 5.62-1.69 5.62-3.76s-2.53-3.75-5.62-3.75z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    fill: "#eaecf0",
    d: "M227.35 601.47l460.77 51.78v14.69L226.18 614.4l1.17-12.93zM226.65 656.05h-8.74V438.97l6.29 1.91.07 6.51 2.38 208.66z"
  }), React.createElement("path", {
    fill: "#d3dae1",
    d: "M230.5 652.55l-3.85 3.5-2.38-208.66-.07-6.51h4.55l.06 6.9 1.69 204.77zM92.83 646.95l127.53-44.43v4.2L92.83 650.8v-3.85z"
  }), React.createElement("path", {
    fill: "#eaecf0",
    d: "M95.11 660.94l-2.28-10.14 127.53-44.08v8.74L95.11 660.94zM688.12 425.14v286.88h-6.65l-.34-266.13-.01-8.51 7-12.24z"
  }), React.createElement("path", {
    fill: "#d3dae1",
    d: "M693.01 423.74v285.83l-4.89 2.45V425.14l4.89-1.4zM586.13 705.73l95.26-53.24 6.73 3.91-101.99 55.62v-6.29z"
  }), React.createElement("path", {
    fill: "#eaecf0",
    d: "M589.11 723.92l-2.98-11.9 101.99-55.62v11.54l-99.01 55.98zM574.76 470.97l.35 302.98h9.45l-1.4-306.48-8.4 3.5z"
  }), React.createElement("path", {
    fill: "#d3dae1",
    d: "M589.11 464.67V771.5l-4.55 2.45-1.4-306.48.56-.26 5.39-2.54z"
  }), React.createElement("path", {
    fill: "#eaecf0",
    d: "M91.61 706.08h-8.05L80.8 435.06l-.04-4.67h7.7l.06 5.33 3.09 270.36z"
  }), React.createElement("path", {
    fill: "#d3dae1",
    d: "M97.2 703.98l-5.59 2.1-3.09-270.36-.06-5.33h5.95l.05 5.85 2.74 267.74z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M583.72 467.21l5.39-2.54v11.9l-5.25 1.75-.14-11.11zM693.01 423.74v18.19l-4.89 1.64-6.99 2.32-.01-8.51 7-12.24 4.89-1.4z"
  }), React.createElement("path", {
    fill: "#d48a9b",
    d: "M693.01 388.75v50.38l-109.15 36.39-.7-53.88 109.85-32.89z"
  }), React.createElement("path", {
    fill: "#efc6cd",
    d: "M79.36 385.25l143.45-27.28 470.2 30.78-109.85 32.89-503.8-36.39z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M94.41 430.39l.05 5.85-5.94-.52-7.72-.66-.04-4.67h13.65zM228.81 447.78l-4.54-.39-6.36-.54v-7.88l6.29 1.91h4.55l.06 6.9z"
  }), React.createElement("path", {
    fill: "#d48a9b",
    d: "M79.36 385.25v46.89l504.5 43.38-.7-53.88-503.8-36.39zM479.37 441h-65.89v-23.91l65.89 4.64V441z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M479.37 441h-65.89v-23.91l65.89 4.64V441z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M324.96 411.85v37.78l252.95 19.24v-40.23l-98.66-5.6-9.8 8.75-40.23-2.8-14.34-10.5-89.92-6.64z"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M323.56 410.44v37.79l252.95 19.24v-40.23l-98.66-5.6-9.79 8.75-40.24-2.8-14.34-10.5-89.92-6.65z"
  }), React.createElement("path", {
    fill: "#d48a9b",
    d: "M167.53 400.3l59.82 4.2-.7 19.01h-39.06l-26.13-10.27 6.07-12.94z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M167.53 400.3l59.82 4.2-.7 19.01h-39.06l-26.13-10.27 6.07-12.94z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M87.76 395.05v33.94l229.51 18.19v-36.04l-88.52-5.24-9.44 6.99-35.69-2.09-14.69-9.1-81.17-6.65z"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M86.36 393.65v33.94l229.51 18.19v-36.03l-88.52-5.25-9.44 7-35.69-2.1-14.69-9.1-81.17-6.65z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M96.65 649.48l1.57-.54-.79 11.16-.78.28v-10.9zM577.94 393.78l32.17 2.11-53.31 15.96-27.15-1.97 48.29-16.1z"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M577.94 392.38l32.17 2.11-53.31 15.95-27.15-1.96 48.29-16.1z"
  }), React.createElement("path", {
    d: "M574.09 395.99c1.27-.54 2.62.48 4 .74.77.15 1.57 0 2.34.15 1.58.21 3.15 1.27 4.65.73M572.43 396.96c1.26-.55 2.62.47 4 .73.77.15 1.57 0 2.35.15 1.58.21 3.14 1.27 4.64.73M568.63 398.88c1.27-.54 2.63.48 4 .74.77.15 1.57 0 2.35.15 1.58.21 3.14 1.27 4.64.73",
    fill: "#d3dae1"
  }), React.createElement("circle", {
    cx: 50,
    cy: 737.26,
    r: 9.39,
    fill: "#535461"
  }), React.createElement("circle", {
    cx: 66.8,
    cy: 773.99,
    r: 9.39,
    fill: "#535461"
  }), React.createElement("circle", {
    cx: 234.33,
    cy: 780.64,
    r: 9.39,
    fill: "#535461"
  }), React.createElement("circle", {
    cx: 271.76,
    cy: 732.71,
    r: 9.39,
    fill: "#535461"
  }), React.createElement("path", {
    fill: "#535461",
    d: "M154.05 571.43h11.76v73.47h-11.76z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M154.05 633h11.76v11.9h-11.76z"
  }), React.createElement("path", {
    fill: "#3a3768",
    d: "M151.78 635.8h16.3v81.52h-16.3z"
  }), React.createElement("path", {
    d: "M269.73 716.79l-106.72-4.37v17.17h123.85a18.92 18.92 0 0 0-17.13-12.8zM56.29 716.79l106.72-4.37v17.17H39.16a18.91 18.91 0 0 1 17.13-12.8z",
    fill: "#3a3768"
  }), React.createElement("path", {
    d: "M151.78 714.17l-85.2 42a21.6 21.6 0 0 0-12 19.35v1.28l99.5-43.38 14-1.05 82.74 52.83a21.58 21.58 0 0 0-8.91-20.5l-73.83-52.27z",
    fill: "#3a3768"
  }), React.createElement("path", {
    d: "M165.81 571.42v7.92q-3.09.13-6.3.13c-1.85 0-3.67 0-5.46-.1v-7.95z",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 159.51,
    cy: 563.98,
    rx: 43.39,
    ry: 12.69,
    fill: "#3a3768"
  }), React.createElement("path", {
    d: "M202.52 563.98a5.18 5.18 0 0 1-1.85 3.67c-5.36 5.22-21.93 9-41.53 9-19.17 0-35.42-3.64-41.17-8.67a5.5 5.5 0 0 1-2.23-4c0-7 19.43-12.69 43.4-12.69s43.38 5.68 43.38 12.69z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M202.89 563.98a5.18 5.18 0 0 1-1.85 3.67c-5.52-1.38-9.34-2.52-9.34-2.52s-38.25 2.14-73.36 2.87a5.5 5.5 0 0 1-2.23-4c0-7 19.43-12.69 43.4-12.69s43.38 5.66 43.38 12.67z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M50 396.84s14.35 39.19 13.65 62.63-11.9 67.52-11.9 67.52-11.19 35.69 17.5 38.84 122.45-2.1 122.45-2.1 35 10.49 46.18 5.94c4.35-1.76 8.12-5.64 11.1-9.73a20.35 20.35 0 0 0-5.28-29.05 60.62 60.62 0 0 0-16.87-7.24 13.55 13.55 0 0 0-3.85-.47l-122.25 2.41s-13.64-2.1-11.19-15.74 6.64-55.63 6.64-55.63.7-51.08-23.79-65.42S50 396.84 50 396.84z",
    fill: "#3a3768"
  }), React.createElement("path", {
    d: "M50 396.72s14.35 39.18 13.65 62.62-11.9 67.53-11.9 67.53-11.19 35.68 17.5 38.83 122.45-2.11 122.45-2.11 35 10.5 46.18 6c4.35-1.77 8.12-5.65 11.1-9.73a20.36 20.36 0 0 0-5.28-29.06 61.22 61.22 0 0 0-16.87-7.24 13.19 13.19 0 0 0-3.85-.46l-122.25 2.37s-13.64-2.1-11.19-15.75 6.64-55.62 6.64-55.62.7-51.08-23.79-65.43S50 396.72 50 396.72z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M52.8 395.44s14.35 39.19 13.65 62.63-11.9 67.52-11.9 67.52-11.19 35.69 17.49 38.84 122.45-2.1 122.45-2.1 35 10.49 46.19 6c4.35-1.77 8.12-5.65 11.1-9.74a20.35 20.35 0 0 0-5.28-29.05 60.62 60.62 0 0 0-16.87-7.29 13.55 13.55 0 0 0-3.85-.47l-122.25 2.41s-13.64-2.1-11.19-15.74 6.64-55.63 6.64-55.63.7-51.08-23.79-65.42-22.39 8.04-22.39 8.04z",
    fill: "#3a3768"
  }), React.createElement("path", {
    d: "M301.04 732.32v12.65s60.43 1.09 73.74 1.09 31.63-6.54 32.72-11.78-15.27-9.6-21.38-9.81-6.32-2.62-14.18-6.77c-4.43-2.34-11.16-9.13-16.18-14.6-3.87-4.22-6.72-7.65-6.72-7.65s-32.51-.65-41.89 4.58c-2.16 1.21-3.65 3.57-4.67 6.5-3.38 9.77-1.44 25.79-1.44 25.79z",
    fill: "#434175"
  }), React.createElement("path", {
    d: "M302.48 706.53c6.82-2.37 46.72-3.29 53.28-3.43-3.87-4.22-6.72-7.65-6.72-7.65s-32.51-.65-41.89 4.58c-2.16 1.21-3.65 3.56-4.67 6.5z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M127.17 504.78l3.52 2.13 1.32.8 5.13 3.08c27.42 16.53 102.21 61.32 106.31 61 1.07-.09 4.29-.57 8.74-1.3 1.18-.19 2.45-.39 3.78-.62 17.13-2.85 45.6-8 48.78-9.42 4.36-2 3.49 6.76 1.74 14.18s-3.05 43-1.09 47.56 1.09 12 1.09 12l-2.61 39.92 1.75 8.48s-5.89 4.8-3.49 7.63.22 15.06.22 15.06c7-2.62 54.32-3.49 54.32-3.49s-2-17.46-.22-21.6.44-28.8.44-28.8 1.09-18.76-.87-23.12.65-32.29.65-32.29 1.75-16.58 2.18-50.4-19.2-34.9-19.2-34.9-2.61-.21-6.59-.59c-7.77-.75-20.73-2.17-29.39-4a50.65 50.65 0 0 1-5.25-1.4c-10.69-3.64-46.68-3.78-52.57-1.16-5.67 2.52-11.34.19-11.76 0l-4.58-7.42-43.76 3.73-4.63.4-43.08 3.67-3 .26z",
    fill: "#565387"
  }), React.createElement("path", {
    d: "M302.57 538.24c12.71 6.2 24.84-15.77 30.49-28.16-7.77-.75-20.73-2.17-29.39-4-5.69 9.51-13.29 26.23-1.1 32.16z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M264.39 389.81a13.19 13.19 0 0 0 1.54 4.26c4.7 9.52 18.31 29.12 18.31 29.12a31.54 31.54 0 0 1 10 10c3.71 6.33 4.8 21.16 4.8 21.16s8.29 32.94 12.21 37.53c2 2.29 1.09 3.65-.27 4.44a19.43 19.43 0 0 0-6.88 6.45c-5.72 9.19-14.85 27.44-2 33.7 17.45 8.51 33.82-36.09 33.82-36.09s-3.28-31.63-4.15-37.08-6.11-27.93-6.11-27.93-3.71-9.6-5.89-16.36-8.72-14.62-8.72-14.62-11.79-23.56-15.06-27.05c-1.52-1.62-3.65-3.66-5.49-5.38-2.13-2-3.89-3.56-3.89-3.56s-22.44 16.19-22.22 21.41z",
    fill: "#ee8e9e"
  }), React.createElement("path", {
    d: "M116.48 729.7l39.7 17.67s51.45 1.09 60.45-1.31 7-12.43-4.8-14.4-14.61-7.19-18.54-9.59c-2.65-1.62-12.06-12.09-17.89-18.72-2.81-3.19-4.8-5.5-4.8-5.5s-7.64-20.29-28.8-15.71a21.73 21.73 0 0 0-10.31 5.45c-11.41 10.56-12.4 31.45-12.4 31.45z",
    fill: "#434175"
  }), React.createElement("path", {
    d: "M132.01 507.71l5.13 3.08c27.42 16.53 102.21 61.32 106.31 61 1.07-.09 4.29-.57 8.74-1.3 1.18-.19 2.45-.39 3.78-.62l.15-.25a50 50 0 0 0 5-12.23c4.58-17.45-18.11-30.76-18.11-30.76l-4.8-3.73c-5.45-9.18-44.72-17.86-44.72-17.86l-5.06-3.45-2.71-1.82-.71-.47-6.14-4.13-30.76 2.18-9.14 5.87-1 .62-3.34 2.19zM131.49 687.59c8.35 28.89 43.23 19.45 43.23 19.45l.66-3.66c-2.81-3.19-4.8-5.5-4.8-5.5s-7.64-20.29-28.8-15.71a21.73 21.73 0 0 0-10.29 5.42z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M122.37 556.48c12.87 0 46 15.49 46 15.49 6.76 5.24 15.92 3.49 15.92 3.49s-16.11 16.36-15.66 23.13-9.17 17.89-9.17 17.89l-29.67 58.68c2.19 41.67 44.94 30.11 44.94 30.11l1.75-9.82c2.62-1.31 6.55-14.4 6.55-14.4s0-5.23 2.61-6.76 8.07-17.24 8.07-17.24 11.78-19.85 11.12-22.46 8.51-15.92 8.51-15.92 15.49-15.27 14.83-18 12.46-16.7 12.46-16.7a43.9 43.9 0 0 0 11.58-13.52 50.13 50.13 0 0 0 5-12.22c3.69-14.06-10.31-25.43-15.9-29.32-1.35-.94-2.21-1.44-2.21-1.44l-4.8-3.73c-2.48-4.18-11.95-8.26-21.55-11.45-6.92-2.31-13.9-4.17-18.37-5.28-3-.73-4.8-1.14-4.8-1.14l-5.06-3.4-1.78-1.2-1.63-1.09-6.15-4.13-13.68 1-17.08 1.21-9.13 5.88-4.36 2.8-17.05 11s-.45 4.19-.59 9.83v1.33c-.23 11.33 1 27.38 9.3 27.38z",
    fill: "#565387"
  }), React.createElement("path", {
    d: "M188.03 312.14l4.6 16.36s8.08 28.15 8.95 30.11 22 21.82 22.91 22.25 12.39 7 12.39 7 .91-36 0-46.46a29.88 29.88 0 0 1 .57-6.86c1.39-8.21 4.91-20.24 7.83-29.51 2.44-7.77 4.47-13.59 4.47-13.59s-51.05-2.19-49.3 2.83c.66 1.9.44 5.07-.19 8.25-1.06 5.24-3.25 10.48-4.61 10.08a17.94 17.94 0 0 0-4.05-.45c-1.86-.08-3.57-.01-3.57-.01z",
    fill: "#ee8e9e"
  }), React.createElement("path", {
    d: "M200.28 302.5a37.76 37.76 0 0 0 45 2.51c2.44-7.77 4.47-13.59 4.47-13.59s-51.05-2.19-49.3 2.83c.68 1.9.46 5.07-.17 8.25z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M186.72 272.22a37.75 37.75 0 1 0 37.75-37.74 37.57 37.57 0 0 0-37.75 37.74z",
    fill: "#ee8e9e"
  }), React.createElement("path", {
    d: "M188.03 312.14l4.6 16.36s8.08 28.15 8.95 30.11 22 21.82 22.91 22.25 12.39 7 12.39 7 .91-36 0-46.46a29.88 29.88 0 0 1 .57-6.86l-3 12.09.22 24.22 1.74 1.31-3.92 5.89v-4.37s-14-13.52-16.15-19.2-10-15.94-10-15.94-9-15-9.16-17.65c-.17-2-3.93-6.76-5.58-8.74-1.86-.08-3.57-.01-3.57-.01zM264.39 389.81a13.19 13.19 0 0 0 1.54 4.26c4.77-.48 21-3.52 24.6-22.08-2.13-2-3.89-3.56-3.89-3.56s-22.47 16.16-22.25 21.38zM113.02 529.03c4.4-3.12 8.59-7.37 11.09-8.54 3.71-1.75 9.38-7.42 9.38-7.42s1.44-1 3.65-2.28c4.05-2.37 10.69-5.81 15.77-6.23 4.55-.38 19.69-1.35 31.59-2.09l15.53-1s14.18-5 20.29-1.75a64.36 64.36 0 0 0 13.74 5v-1.3l-4.58-7.42-48.39 4.13-6.15-4.13-30.76 2.18-9.13 5.88-7.88.67 3.52 2.13-17.05 11s-.52 4.88-.62 11.17z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M106.63 530.96a19.87 19.87 0 0 0 6.39-3.26c4.39-3.11 8.57-7.35 11.06-8.52 3.71-1.75 9.38-7.42 9.38-7.42s11.57-7.86 19.42-8.51c2.14-.18 6.62-.49 12-.84l17.81-1.14 9.24-.58 8.07-.49s14.18-5 20.29-1.75a64.36 64.36 0 0 0 13.74 5s.22-15.27 2-21.6 4.14-17.89 4.14-17.89 2-15.92 3.93-23.12 9.6-47.34 13.53-50 6.1 2 6.1 2 26.18-.44 26.62-29.23c0 0-12.22-12.22-13.09-15.27s-12.43-14.4-12.43-14.4-6.55-12.22-14-12.44a58.74 58.74 0 0 0-10.5.33l-6.3 25.63.22 24.22 1.75 1.31-3.93 5.89v-4.29s-14-13.53-16.14-19.2-10-15.95-10-15.95-8.94-15-9.16-17.65-6.33-9.63-6.33-9.63a15.5 15.5 0 0 0-3.71 0 4 4 0 0 1-1.62-.23 21.91 21.91 0 0 0-10.9-.62c-7.54 1.57-19 4.43-22.16 7.86-4.8 5.24-11.78 10.26-19.64 32.07l42.32 15.27-3.62 6.89-33.68 64s-1.12 1.82-2.63 4.19c-2 3.08-4.59 7.11-6.32 9.32-3.05 3.93-2.18 16.36-2.18 16.36s-.65 5.89-2.83 8.08-1.76 10.24-1.76 10.24l-5.67 21.16s-5.24 4.8-5.24 7-4.14 8.29-4.14 8.29-6.33 10.44-.03 8.92z",
    fill: "#dfe5ee"
  }), React.createElement("path", {
    d: "M134.79 441.59a33 33 0 0 1 .67 3.65s17.23 40.36 19.41 42.76c.67.74 3.21 4.37 6.39 9l3.65 5.39c6.59 9.79 14 20.91 14 20.91l16.14 14.18s35.12 2.81 46.28-8.59c-1.35-.94-2.21-1.44-2.21-1.44l-4.8-3.73c-2.48-4.18-11.95-8.26-21.55-11.45-8.84.06-16.07.78-16.07.78l-2.3-6.06-2.4-6.32-12.24-32.08s-7.87-40.57-10.49-42.54-2-8.07-2-8.07 4.8-17.23 3.05-19.63 2.84-20.08 2.84-20.08a18.11 18.11 0 0 0-2.1-4.89l-33.68 64s-1.08 1.81-2.59 4.21z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M173.63 376.94s-4.58 17.67-2.83 20.07-3.06 19.63-3.06 19.63-.65 6.11 2 8.07 10.49 42.54 10.49 42.54l16.9 44.51s52.89-5.24 47.44 11.34-49.09 13.09-49.09 13.09l-16.14-14.18s-21.82-32.94-24-35.34-19.42-42.76-19.42-42.76-.87-8.07-4.58-12.22-.87-11.15-.87-11.15-4.58-52.77.22-59.09 37.94-3.49 42.94 15.49z",
    fill: "#ee8e9e"
  }), React.createElement("path", {
    d: "M330.06 546.66s-13.75 4.59-17.43 11.13 17.43-11.13 17.43-11.13zM323.07 532.27c-.43.65-18.82 19.1-17.67 23.56s17.67-23.56 17.67-23.56zM222.07 545.36s-20.51 9.67-22.26 13.88 22.26-13.88 22.26-13.88zM220.76 557.79s-18.51 7.85-21 9.82 21-9.82 21-9.82zM212.25 574.59s-8.2 6.11-12.72 1.31 12.72-1.31 12.72-1.31zM243.01 415.33c-.44.66-27.71 49.74-34.91 53.45s34.91-53.45 34.91-53.45zM241.7 433.88c0 1.09-26.62 58-31 58.68s31-58.68 31-58.68zM140.47 470.53s-12.84 27.45-17.84 29.06 17.84-29.06 17.84-29.06zM138.29 458.31s-4.43 9.6-7.12 9.6 7.12-9.6 7.12-9.6zM186.72 272.22a37.57 37.57 0 0 0 2.39 13.21 35.64 35.64 0 0 1 37.23-36.62c1.83.08 4 .51 4.74 2.17a9.12 9.12 0 0 1 .45 2.76c.55 4.24 4.85 6.89 8.89 8.27s8.54 2.26 11.47 5.37c2.68 2.85 3.44 6.94 4.76 10.63a15.26 15.26 0 0 0 3.68 6 37.75 37.75 0 1 0-73.61-11.79z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M257.21 238.05c-3.1-4.21-8.6-5.67-13.38-7.79a42.45 42.45 0 0 1-23.79-28.91 14.9 14.9 0 0 0 1.46 18.58c-8.69-.59-18.29-1.59-24.18-8-1.34 4.62 2.67 9.87.48 14.15-1.88 3.68-7 4-10.31 6.5-3.53 2.62-4.7 7.37-4.92 11.76s.24 8.89-1.06 13.09c-1 3.19-3 6.12-3.2 9.45a16.2 16.2 0 0 0 1.6 7.17 64.74 64.74 0 0 0 9.92 16.48 35.7 35.7 0 0 1 36.51-43c1.83.08 4 .52 4.74 2.18a9 9 0 0 1 .45 2.76c.55 4.23 4.85 6.88 8.89 8.26s8.54 2.27 11.47 5.37c2.68 2.85 3.44 6.94 4.76 10.63s3.87 7.55 7.76 8c.89-5.48 1.79-11 1.24-16.56-.6-5.95-4.6-9.32-6-14.5-1.52-5.43 1.36-10.46-2.44-15.62z",
    fill: "#603556"
  }), React.createElement("path", {
    d: "M146.63 343.78l-13.74 8.29s-3.93 13.3-7 15c0 0 27.49-15.27 48.21 19.85 0 0-.65-4.58 2.18-6.76s2.18-11.56 2.18-11.56a39.54 39.54 0 0 0 2-4.59c1.9-4.75-8.35-32.23-33.83-20.23z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M146.15 342.9l-13.75 8.29s-3.93 13.31-7 15.06c0 0 27.49-15.28 48.21 19.85 0 0-.65-4.58 2.19-6.76s2.18-11.57 2.18-11.57a37.43 37.43 0 0 0 2-4.58c1.94-4.8-8.35-32.29-33.83-20.29z",
    fill: "#dfe5ee"
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M198.46 222.93c-.05-3.56-2.17-7.48-1.14-11l.18.19c.25 3.64 2.27 7.47.96 10.81zM183.01 241.7c-.21 4 .15 8-.75 11.89.33-3.05.15-6.19.31-9.27a25.68 25.68 0 0 1 .57-4.34c-.06.61-.11 1.15-.13 1.72zM178.31 266.86a10.85 10.85 0 0 1 .43-2.34 16.67 16.67 0 0 0 1.61 6.89 64.58 64.58 0 0 0 8.9 15.2 34.61 34.61 0 0 0 .58 3.9 64.74 64.74 0 0 1-9.92-16.48 16.2 16.2 0 0 1-1.6-7.17zM221.94 217.31c-.84-.05-1.7-.11-2.55-.18a15.37 15.37 0 0 1-1.45-11.27 14.74 14.74 0 0 0 4 11.45zM197.98 257.44a36.28 36.28 0 0 1 28.79-12.56c1.83.09 4 .52 4.75 2.18a9.38 9.38 0 0 1 .45 2.76c.55 4.23 4.84 6.89 8.89 8.26s8.53 2.27 11.46 5.38c2.69 2.85 3.45 6.94 4.77 10.62s3.86 7.54 7.74 8l-.42 2.62c-3.89-.42-6.44-4.28-7.76-8s-2.08-7.78-4.76-10.63c-2.93-3.1-7.43-4-11.47-5.37s-8.34-4-8.89-8.26a9 9 0 0 0-.45-2.76c-.78-1.66-2.91-2.1-4.74-2.18a35.52 35.52 0 0 0-36.5 28.59 36.12 36.12 0 0 1 8.14-18.65z"
  })), React.createElement("path", {
    fill: "#3a3768",
    d: "M431.8 339.65v39.13l-37.44-3v-36.13h37.44z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M431.8 375.58v3.2l-37.44-3v-3.2l37.44 3z"
  }), React.createElement("path", {
    d: "M443.24 381.59l-58.24-3a5.7 5.7 0 0 1 5.7-5.7l46.84 3a5.7 5.7 0 0 1 5.7 5.7zM514.37 350.4l-201.45-6a6.12 6.12 0 0 1-6.13-6.13v-119a6.12 6.12 0 0 1 6.13-6.12l201.45 6a6.13 6.13 0 0 1 6.13 6.12v119a6.13 6.13 0 0 1-6.13 6.13z",
    fill: "#3a3768"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M515.55 341.7l-204.26-6V228.48l204.26 6V341.7z"
  }), React.createElement("ellipse", {
    cx: 413.42,
    cy: 222.94,
    rx: 1.8,
    ry: 1.78,
    fill: "#fff"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M431.76 347.06l-37.32-.6v1.27h37.32v-.67zM363.8 383.88l51.11 3.35-10.89 15.65-56.19-6 15.97-13z"
  }), React.createElement("path", {
    fill: "#3a3768",
    d: "M362.8 382.88l51.11 3.35-10.89 15.65-56.19-6 15.97-13z"
  }), React.createElement("path", {
    fill: "#d5e1f4",
    d: "M365.06 384.04l44.57 2.72-9.49 12.75-49.01-4.89 13.93-10.58z"
  }), React.createElement("ellipse", {
    cx: 883.43,
    cy: 794.36,
    rx: 64.2,
    ry: 9.85,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M919.51 561.88s7.13 9.33-3.3 23.42-19 26-15.55 34.76c0 0 15.74-26.17 28.54-26.53s4.43-15.94-9.69-31.65z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M919.51 561.88a11.71 11.71 0 0 1 1.45 2.92c12.5 14.69 19.16 28.39 7.15 28.73-11.19.32-24.61 20.32-27.83 25.38a11.9 11.9 0 0 0 .38 1.15s15.74-26.17 28.54-26.53 4.43-15.94-9.69-31.65z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M932.77 573.77c0 3.28-.37 6-.82 6s-.83-2.67-.83-6 .46-1.74.92-1.74.73-1.54.73 1.74z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M937.32 577.69c-2.88 1.57-5.4 2.52-5.61 2.12s1.94-2 4.82-3.57 1.75-.42 2 0 1.68-.12-1.21 1.45z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M881.82 561.88s-7.14 9.33 3.29 23.42 19 26 15.55 34.76c0 0-15.73-26.17-28.54-26.53s-4.39-15.94 9.7-31.65z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M881.82 561.88a11.49 11.49 0 0 0-1.46 2.92c-12.49 14.69-19.15 28.39-7.14 28.73 11.19.32 24.61 20.32 27.82 25.38a9.67 9.67 0 0 1-.38 1.15s-15.73-26.17-28.54-26.53-4.39-15.94 9.7-31.65z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M868.56 573.77c0 3.28.36 6 .82 6s.82-2.67.82-6-.46-1.74-.91-1.74-.73-1.54-.73 1.74z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M864 577.69c2.89 1.57 5.4 2.52 5.62 2.12s-2-2-4.83-3.57-1.74-.42-2 0-1.67-.12 1.21 1.45z",
    fill: "#ffd037"
  }), React.createElement("ellipse", {
    cx: 900.66,
    cy: 679.99,
    rx: 74.6,
    ry: 11.45,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M939.06 607.48l-.36 2.92-.5 4.11-.21 1.72-.5 4.11-.21 1.72-.5 4.11-5.71 46.8c-.51 4.18-7.34 7.43-15.58 7.43h-29.66c-8.24 0-15.05-3.25-15.56-7.43l-5.72-46.8-.5-4.11-.21-1.72-.51-4.11-.21-1.72-.5-4.11-.35-2.92c-.29-2.36 3.4-4.36 8.06-4.36H931c4.63 0 8.35 2 8.06 4.36z",
    fill: "#65617d"
  }), React.createElement("path", {
    fill: "#9d9cb5",
    d: "M938.7 610.4l-.5 4.11h-75.07l-.5-4.11h76.07zM937.99 616.23l-.5 4.12h-73.65l-.51-4.12h74.66zM937.28 622.06l-.5 4.12h-72.23l-.5-4.12h73.23z"
  }));
};
UndrawWorkTime.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawWorkTime;